import React from 'react';

interface FieldsContainerProps {
  children: React.ReactNode;
  columns?: 2 | 3 | 4;
  className?: string;
}

const columnClasses = {
  2: 'grid grid-cols-1 md:grid-cols-2 gap-4',
  3: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4',
  4: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4',
};

export const FieldsContainer: React.FC<FieldsContainerProps> = ({ children, columns = 3, className = '' }) => {
  return <div className={`px-6 py-4 ${columnClasses[columns]} ${className}`}>{children}</div>;
};
